import { getStoredValue, readTrackingIdsCookie } from "./tracking";
import { trackEvent } from "./clientEvents";

export function trackQuoteCompletedOnce(): void {
  const leadOrigin = getStoredValue("lead_origin");
  const trackingIds = readTrackingIdsCookie();
  const normalizedLeadOrigin = (leadOrigin || "").toLowerCase();

  const trackingFlags = {
    leadOrigin: normalizedLeadOrigin || null,
    hasGclid: !!trackingIds.gclid,
    hasGbraid: !!trackingIds.gbraid,
    hasWbraid: !!trackingIds.wbraid,
    hasDclid: !!trackingIds.dclid,
  };

  const isGoogleAdsLead =
    normalizedLeadOrigin === "google_ads" ||
    normalizedLeadOrigin.endsWith("-google_ads") ||
    Boolean(
      trackingIds.gclid ||
      trackingIds.gbraid ||
      trackingIds.wbraid ||
      trackingIds.dclid,
    );

  if (!isGoogleAdsLead) {
    trackEvent("quote_conversion_skipped", {
      reason: "not_google_ads_lead",
      ...trackingFlags,
    });
    return;
  }

  if ((window as any).__quoteTracked) {
    trackEvent("quote_conversion_skipped", {
      reason: "already_tracked",
      ...trackingFlags,
    });
    return;
  }
  (window as any).__quoteTracked = true;

  const gtagFn = (window as any).gtag;
  if (!gtagFn) {
    trackEvent("quote_conversion_skipped", {
      reason: "no_gtag",
      ...trackingFlags,
    });
    return;
  }

  if (process.env.REACT_APP_TARGET_ENV !== "production") {
    console.log("trackQuoteCompletedOnce sending conversion event to Google Ads");
  }
  gtagFn("event", "conversion", {
    send_to: "AW-975160998/EQLUCOe-zfcbEKaN_9AD",
  });

  trackEvent("quote_conversion_fired", trackingFlags);
}

export function trackQuoteStepPageView(stepName: string): void {
  const gtagFn = (window as any).gtag;
  if (!gtagFn) return;

  const stepSlug = stepName
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/\s+/g, "-")
    .toLowerCase();

  // Include the basename (e.g., /app/quote) to match actual URLs
  const basename = process.env.PUBLIC_URL || "";
  const pagePath = `${basename}/${stepSlug}`.replace(/\/+/g, "/"); // Remove duplicate slashes
  const pageLocation = `${window.location.origin}${pagePath}`;

  gtagFn("event", "page_view", {
    page_title: `Quote - ${stepName}`,
    page_path: pagePath,
    page_location: pageLocation,
  });
}
